import { InputConfig, FieldTypes } from '@tmhcc-ng-lib/framwork/form-inputs';
import { DateService } from '@tmhcc-ng-lib/framwork/services';

export class BusinessInfoConfig {
  constructor(protected dateService: DateService) {}

  BusinessInfo: InputConfig[] = [
    {
      fieldInfo: {
        fieldName: 'claimAttorny',
        label: '',
        decimal: 0,
        showLabel: true,
        fieldType: FieldTypes.LookupList
      },
      config: {
        selectConfig: {
          options: [],
          placeholder: 'Select Attorney',
          selectedOption: [],
          optionConfig: {
            displayKey: 'Description',
            search: true,
            limitTo: 3
          },
          multiple: false
        },
        isDisabled: false
      }
    }
  ];
}
